/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {dlsColor} from '@ion/dls/src/theme/theme';

export type TagsTabKey = 'assigned' | 'nearby';

export interface TagsCoachingTextProps {
  activeTab: TagsTabKey;
}

// Figma's own per-tab sentences (Tags Tab bar "Coaching/context Text" -
// "All nearby tags not assigned to this asset." - and the matching sentence
// on the Assigned tab's own full-accordion mockups) ...
const COACHING_TEXT: Record<TagsTabKey, string> = {
  assigned : 'All tags currently assigned to this asset.',
  nearby   : 'All nearby tags not assigned to this asset.'
};

const useStyles = makeStyles(() => ({
  text : {
    width      : '100%',
    display    : 'block',
    paddingTop : '8px',
    fontFamily : 'Inter',
    fontWeight : 500,
    fontSize   : '14px',
    lineHeight : '20px',
    color      : dlsColor('grey3')
  }
}));

/**
 * TagsCoachingText renders the short sentence shown beneath the Tags
 * accordion's tab bar (ION-7463), describing what the active tab lists.
 * Each tab has its own unique message.
 *
 * ```typescript
 *
 *   import {TagsCoachingText} from
 *     '@ion/dls/src/components/assetdetails/current/TagsCoachingText';
 *   ...
 *
 *   <TagsCoachingText activeTab='assigned' />
 *   <TagsCoachingText activeTab='nearby' />
 *
 * ```
 *
 */
export const TagsCoachingText = ({activeTab}: TagsCoachingTextProps) => {
  const classes = useStyles();
  return (
    <span className={classes.text}>
      {COACHING_TEXT[activeTab]}
    </span>
  );
};

export default memo(TagsCoachingText);
